import type { RotationsRow } from "@/types/tables";

export const buildRotationRows = (data: {
  rotations: any[];
  sessions: any[];
}): RotationsRow[] => {
  const rotations = Array.isArray(data?.rotations) ? data.rotations : [];
  const sessions = Array.isArray(data?.sessions) ? data.sessions : [];

  const sessionsByRotationId = new Map<string, string[]>();

  for (const s of sessions) {
    const arr = sessionsByRotationId.get(s.rotation);
    if (arr) arr.push(s.name);
    else sessionsByRotationId.set(s.rotation, [s.name]);
  }

  return rotations.map((r) => ({
    rotationId: r._id,
    rotationDate: r.date,
    sessions: sessionsByRotationId.get(r._id) ?? [],
    teachersCanCreate: Boolean(r.teachersCanCreate),
    studentsCanView: r.studentsCanView,
    studentsCanSignup: r.studentsCanEdit,
  }));
};
